import React from 'react';
import {
  FolderOpen, Volume2, Type as TypeIcon, Captions, Wand2, Shuffle,
  Palette, Sparkles, LayoutTemplate, ChevronsLeft, ChevronsRight,
} from 'lucide-react';

export const TOOL_CATEGORIES = [
  { key: 'media', label: 'Media', icon: FolderOpen },
  { key: 'audio', label: 'Audio', icon: Volume2 },
  { key: 'text', label: 'Text', icon: TypeIcon },
  { key: 'captions', label: 'Captions', icon: Captions },
  { key: 'effects', label: 'Effects', icon: Wand2 },
  { key: 'transitions', label: 'Transitions', icon: Shuffle },
  { key: 'brand', label: 'Brand Kit', icon: Palette },
  { key: 'ai', label: 'AI Tools', icon: Sparkles },
  { key: 'templates', label: 'Templates', icon: LayoutTemplate },
];

/**
 * Narrow vertical icon rail (CapCut-style) for the Main Editor. Clicking a
 * category opens/updates the adjacent expandable tool panel in
 * UnifiedEditor.jsx; clicking the already-active category, or the chevron
 * at the bottom, collapses the panel so the preview can expand.
 */
export function EditorToolSidebar({ activeCategory, onSelectCategory, collapsed, onToggleCollapsed, categories = TOOL_CATEGORIES }) {
  return (
    <div className="w-14 shrink-0 glass border border-white/5 rounded-xl py-3 flex flex-col items-center gap-1" data-testid="editor-tool-sidebar">
      {categories.map((cat) => {
        const Icon = cat.icon;
        const isActive = !collapsed && activeCategory === cat.key;
        return (
          <button
            key={cat.key}
            type="button"
            title={cat.label}
            onClick={() => {
              if (!collapsed && activeCategory === cat.key) { onToggleCollapsed(); return; }
              onSelectCategory(cat.key);
              if (collapsed) onToggleCollapsed();
            }}
            className={`w-11 h-11 rounded-lg flex flex-col items-center justify-center gap-0.5 transition-colors ${
              isActive ? 'bg-[#3A7BFF]/15 text-[#3A7BFF]' : 'text-[#8A93A6] hover:bg-white/5 hover:text-white'
            }`}
            data-testid={`editor-sidebar-tool-${cat.key}`}
          >
            <Icon className="h-4.5 w-4.5" />
            <span className="text-[8px] leading-none">{cat.label.split(' ')[0]}</span>
          </button>
        );
      })}
      <div className="flex-1" />
      <button
        type="button"
        onClick={onToggleCollapsed}
        title={collapsed ? 'Expand tool panel' : 'Collapse tool panel'}
        className="w-11 h-9 rounded-lg flex items-center justify-center text-[#555E6E] hover:text-white hover:bg-white/5 transition-colors"
        data-testid="editor-sidebar-collapse-toggle"
      >
        {collapsed ? <ChevronsRight className="h-4 w-4" /> : <ChevronsLeft className="h-4 w-4" />}
      </button>
    </div>
  );
}
